import { ReactNode } from 'react';
import AuthGuard from './AuthGuard';
import RequireOnboarding from './RequireOnboarding';
import RequireTermsAccepted from './RequireTermsAccepted';

/**
 * Combinação de `AuthGuard` + `RequireTermsAccepted` + `RequireOnboarding`.
 *
 * Usar em todas as rotas autenticadas EXCETO `/onboarding`, `/login`, `/`,
 * `/termos` (essas ou são públicas ou exigem apenas auth).
 *
 * Ordem importa: termos vem antes do onboarding — não faz sentido escolher
 * tipo de conta se o usuário ainda não concordou com os termos.
 */
export default function Protected({ children }: { children: ReactNode }) {
  return (
    <AuthGuard>
      <RequireTermsAccepted>
        <RequireOnboarding>{children}</RequireOnboarding>
      </RequireTermsAccepted>
    </AuthGuard>
  );
}
